<template>
    <div>
        <div class="row" style="margin:0px">

            <div v-if="sectionDocument == 'H1B'">
                <div class="col-md-12">
                    <div class="col-md-10 document-list" :class="statusClass">

                        <!-- Header -->
                        <div class="document-list__header clearfix">
                            <div class="document-list__heading" v-bind:class="{ 'showExpired': previousList }">
                                <span class="document-list__title">{{documentList.DisplayName}}</span>
                                <template>
                                    <span class="document-list__status" v-bind:class="{ 'showExpiredStaus': previousList }" style="font-size: 10px; padding: 2px 5px;">&#10003;</span>
                                </template>
                            </div>
                        </div>

                        <!-- Body -->
                        <div v-if="showMetaDataValues">
                            <div class="document-list__body">
                                <div class="row col-md-12">
                                    <div class="col-md-3" v-for="(h, index) in documentsTableData[0].DocumentData" v-if="h.ShowField" :key="index" style="padding: 5px 5px !important;">
                                        <div>
                                            <span class="headerStyle">{{h.NameToDisplay}}</span>
                                            <a class="historylink" v-if="documentList.DocumentType == 'DirectDeposit' && h.Key == 'EffectiveDate' && documentList.DirectDepositBankDetails && documentList.DirectDepositBankDetails.length > 0" @click="openEffectiveDateHistory(documentList.DirectDepositBankDetails)">(View History)</a>
                                            <br>
                                            <span class="dataStyle single_line_text" v-if="h.Value" v-tooltip="h.Value">{{h.Value}}</span>
                                            <span class="dataStyle" v-else> N/A</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="row col-md-12" v-if="GetShowNotes(documentsTableData[0].DocumentData)">
                                    <div class="col-md-3" v-for="(h, index) in documentsTableData[0].DocumentData" v-if="h.Key == 'Notes'" :key="index" style="padding: 5px 5px !important;">
                                        <span class="headerStyle">{{h.Key == 'Notes' ? "Comments" : ''}}</span><br>
                                        <span class="dataStyleNotes single_line_text" v-tooltip="h.Value">{{(h.Key == 'Notes') ? h.Value != null && h.Value !='' ? h.Value : 'N/A' : ''}}</span>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-2 document-list__controls" v-if="IsDocumentURLExists">
                        <ob-dropdown title="Actions">
                            <ob-dropdown-list-item @click.native="viewDocument">View Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item @click.native="downloadDocument">Download Document</ob-dropdown-list-item>
                        </ob-dropdown>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="col-md-12" style="padding: 0px;">
                    <div class="col-md-10 document-list" :class="statusClass">
                        <!-- Header -->

                        <div class="document-list__header clearfix">
                            <div class="document-list__heading" v-bind:class="{ 'showExpired': previousList }">
                                <span class="document-list__title">{{documentList.DisplayName}}</span>
                                <template>
                                    <span class="document-list__status" v-bind:class="{ 'showExpiredStaus': previousList }" style="font-size: 10px; padding: 2px 5px;">&#10003;</span>
                                </template>
                            </div>

                        </div>

                        <!-- Body -->
                        <div class="document-list__body" v-if="documentsTableData.length > 0 && documentsTableData[0].DocumentData">
                            <div class="row col-md-12">
                                <div class="col-md-3" v-for="(h, index) in documentsTableData[0].DocumentData" :key="index" style="padding: 5px 5px !important;">
                                    <div v-if="h.ShowField">
                                        <span class="headerStyle">{{h.NameToDisplay}}</span><br>
                                        <span class="dataStyle single_line_text" v-if="h.Value != '' && h.Value != null" v-tooltip="h.Value">{{h.Value}}</span>
                                        <span class="dataStyle" v-else> N/A </span>
                                    </div>
                                </div>
                            </div>
                            <!-- <table width="100%">
                                <thead style="background: none;">
                                    <tr>
                                        <th v-for="(h, index) in documentsTableHeader" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description' && h.Key != 'MemberId'" :key="index" class="headerStyle">
                                            {{h.DisplayName}}
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td v-for="(h, hIndex) in documentsTableData[0].DocumentData" v-if="h.Key !== 'DocumentUrl' && h.Key !== 'SignedDocumentUrl' && h.Key !== 'Description' && h.Key != 'MemberId'" :key="hIndex" class="dataStyle">
                                            <span v-if="h.Value != '' && h.Value != null">{{h.Value}}</span>
                                            <span v-else> N/A </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table> -->
                        </div>
                    </div>
                    <div class="col-md-2 document-list__controls" style="padding:0px;text-align:right;">
                        <ob-dropdown title="Actions">
                            <ob-dropdown-list-item @click.native="viewDocument">View Document</ob-dropdown-list-item>
                            <ob-dropdown-list-item @click.native="downloadDocument">Download Document</ob-dropdown-list-item>
                        </ob-dropdown>
                    </div>

                </div>
                <div v-if="documentList.Group != 'RightToControlDocuments'">
                    <div v-if="canUploadMultiple === true && !isReadOnly && documentType == 'OtherDocuments'" style="text-align: right; margin: 10px 0 0;">
                     <a href="javascript:;" style="font-style: italic;" @click="uploadDocument()">+ Upload New {{listName}}</a>
                    </div>
                </div>
            </div>
        </div>

        <template>
            <ob-modal2 :show.sync="show" :backdrop="false">
            <template slot="modal-title">
                <template>
                    {{modalType}} {{listName}}
                </template>
            </template>
            <template slot="modal-body">
                <transition name="slide-fade">
                <ob-dynamic-form-fields-ess v-if="show" :validate="doValidation" :isValid.sync="isFormValid" :field-list="documentsTableHeader" :documentGroup="documentGroup" :documentType="documentType" :field-values.sync="fieldValues" :isUploading.sync="isUploading"></ob-dynamic-form-fields-ess>
                </transition>
            </template>
            <template slot="modal-footer">
                <!-- Workaround for showing tooltip when the buttons are disabled-->
                <template v-if="isUploading">
                <ob-button type="secondary" :disabled="isUploading">
                    <span v-tooltip="{ content: 'Please wait for the document to upload', visible: isUploading }">Cancel</span>
                </ob-button>
                <ob-button type="primary" :disabled="isUploading">
                    <span v-tooltip="{ content: 'Please wait for the document to upload', visible: isUploading }">{{modalType}}</span>
                </ob-button>
                </template>
                <template v-else>
                <ob-button type="secondary" @click="cancelUpload">Cancel</ob-button>
                <ob-button type="primary" @click="upload">{{modalType}}</ob-button>
                </template>
            </template>
            </ob-modal2>
        </template>

        <template>
            <ob-modal2 :show.sync="openEffectiveDateHistoryPopup" width="840px" :backdrop="false">
                <template slot="modal-title">History</template>
                <template slot="modal-body">
                    <effective-date-history v-if="openEffectiveDateHistoryPopup" :effectiveDateData="effectiveDateData"></effective-date-history>
                </template>
                <template slot="modal-footer">
                    <ob-button type="primary" @click="closePopUp">Close</ob-button>
                </template>
            </ob-modal2>
        </template>
    </div>
</template>



<script>
  import c from '@/components/Core/constants.js'
  import utils from '@/components/Core/utils.js'


  export default {
    name: 'ob-ess-document',
    props: {
        documentList: {
            type: Object,
            required: true
        },
        fileUploadUrl: {
            type: String
        },
        actionList: {
            type: Array
        },
        readOnly: {
            type: Boolean,
        },
        versioning: {
            type: Boolean
        },
        isProjectTab: {
            type: Boolean
        },

        previousList: {
            type: Boolean
        },
        sectionDocument:{
            type: String
        }
    },


    data() {
        return {
            msgShow:false,
            requestDocName:'',
            showESignPending: false,
            doValidation: false,
            isFormValid: false,
            isUploading: false,
            show: false,
            show1: false,
            oldFieldValues: {},
            fieldValues: {},
            modalType: "",
            dateTimeKeys: [
                    "IssueDate",
                    "ExpiryDate",
                    "PODate",
                    "I94StartDate",
                    "I94EndDate",
                    "SignedDate",
                    "CertifiedDate",
                ],
            checkUserFileAccess:false,
            requestType: 'eSign',
            request: {
            },
            esignDocId:'',
            openESign:false,
            esignDocUrl:'',
            interviewStatus: '',


            //popups
            showUploadExtend: false,
            showUploadApproved: false,
            //props popups
            dataEAD: '',
            entireDataCard: '',
            dataEADApproval: '',

            eadCardUpdate: false,
            eadReceiptUpdate: false,
            DocumentUrl: '',
            effectiveDateData:'',
            openEffectiveDateHistoryPopup:false,
        }
    },

    created() {
    },


    computed: {
        showMetaDataValues(){
            return this.documentsTableData.length > 0 && this.documentsTableData[0].DocumentData && this.documentsTableData[0].DocumentData.length > 0
        },

        IsDocumentURLExists() {
            if(this.documentList && this.documentList.MetadataValues && this.documentList.MetadataValues.length > 0){
                let data = this.documentList.MetadataValues[0].DocumentData

                if(data && data.length > 0)
                    return data.some(x => x.Key && x.Key == "DocumentUrl" && x.Value)
            }
            return false
        },

        getEadCard() {
            return this.entireData.EADCard
        },

        getEADReceiptNotice() {
            return this.entireData.EADReceiptNotice
        },

        requestedList(){
                return this.documentList.RequestDocStatus || []
        },
        canBeVersioned() {
            return this.versioning || false
        },
        canBeApproved() {
            return this.documentList.CanBeApproved || false
        },

        tooltipContent() {
            return this.documentList.DocTypeToolTip || ''
        },
        isReadOnly() {
            return this.readOnly || false
        },
        listName() {
            return this.documentList.DisplayName || 'N/A'
        },
        documentGroup() {
            return this.documentList.Group || ''
        },
        documentType() {
            return this.documentList.DocumentType || ''
        },
        LCAId() {
            return this.$store.getters.getLCAId
        },
        IsDocumentRequired(){
            return this.documentList.IsDocumentRequired || false
        },
        canESign() {
            return this.documentList.CanESign
        },
        canUploadMultiple() {
            return this.documentList.UploadMultiple
        },

        documentsTableHeader() {
            return this.documentList.Metadata || []
        },
        documentsTableData() {
            let list = [];
            let restrictedKeys = [ "SignedDocumentUrl", "DocumentUrl", "Description", "IsAlertWhenExpiring" ]

            this.documentList.MetadataValues.forEach((td) => {
                let doc = { DocumentData : []}
                
                this.documentsTableHeader.forEach((m) => {
                    if(td.DocumentData.some(k => k.Key == m.Key)){
                        let keyValuePair = td.DocumentData.find(k => k.Key == m.Key);
                        let objValue  = {
                            Key : keyValuePair.Key,
                            Value : keyValuePair.Value,
                            ShowField : true,
                            NameToDisplay : m.DisplayName
                        }
                        if(restrictedKeys.includes(keyValuePair.Key) || (m.DocType == "I94" && keyValuePair.Key == "MemberId") || (keyValuePair.Key == "Notes" && !keyValuePair.Value) 
                         || (this.documentGroup == "CourierDocuments" && keyValuePair.Key == "OtherCourier" && !keyValuePair.Value)){
                            objValue.ShowField = false
                        }
                        if(keyValuePair.Key == "EmployerContribution" && keyValuePair.Value){
                            objValue.Value = keyValuePair.Value + "%"
                        }
                        doc.DocumentData.push(objValue)
                    }
                })
                list.push(doc)
            })
            return list
        },

        statusClass() {
            return 'document-list--success'
        },
        H1BId(){
            return this.documentList.h1bID
        },
        ConsultantId(){
            return this.$route.params.id
        },
        JobId(){
            return this.documentList.jobid
        },
        DisplayText(){
            return this.documentList.DisplayText || ''
        },
        docModelFlag(){
            if(this.requestDocName == '')
                return true
            else
                return false
        }
    },

    mounted() {

    },

    methods: {

        commParent() {
            this.$emit('updateDoc')
        },

        approveOrRejectDocument(id, status) {
            if (status == 'Validated') {
                this.$loading({ 'loadingText': 'Approving the document...' })
            } else if (status == 'Rejected') {
                this.$loading({ 'loadingText': 'Rejecting the document...' })
            }


            ajax.put(`/Compliance/UpdateDocumentStatus?id=${id}&status=${status}`, {}, (res) => {
                this.$loading().close()
                if (res.data.State === true) {
                    if (status == 'Validated') {
                        this.$message({
                            type: 'success',
                            message: 'Document approved'
                        })

                        this._updateApprovalStatus('Validated')
                    } else if (status == 'Rejected') {
                        this.$message({
                            type: 'success',
                            message: 'Document rejected'
                        })

                        this._updateApprovalStatus('Rejected')

                    }
                } else {
                    this.ESSEnableDisable(res) 
                    this.$message({
                        type: 'error',
                        message: res.data.Message
                    })
                }
            })
        },
        viewDocument() {
            this.documentList.MetadataValues[0].DocumentData.forEach((s) => {
                if (s.Key == "DocumentUrl" && s.Value){
                    this.DocumentUrl = s.Value
                }
            })
            utils.previewSingleDoc(this.DocumentUrl)
        },

        downloadDocument() {
            this.documentList.MetadataValues[0].DocumentData.forEach((s) => {
                if (s.Key == "DocumentUrl" && s.Value){
                    this.DocumentUrl = s.Value
                }
            })
            utils.downloadSingleDoc(this.DocumentUrl)
        },

        updateDocument() {
            this.dataEAD = this.documentList


            if (this.documentType == "EADCardInfo") {

                this.eadCardUpdate = true
                this.showUploadApproved = true

            } else if (this.documentType == "EADCardReceiptNotice") {

                this.eadReceiptUpdate = true
                this.showUploadExtend = true

            }
        },

        removeDocument() {
            this.$loading({ 'loadingText': 'Removing the file...' })
            var docID = this.documentList.MetadataValues[0].DocumentId
            ajax.put(`/Onboarding/RemoveDocument?documentId=${docID}&entityTypes=${this.documentList.EntityType}`, {},(res) => {
                if (res.data.State === true) {
                    setTimeout(() => {
                        this.$loading({}).close()
                        this.$emit("removeDoc")
                    }, 2000)
                    this.$message({
                        type: 'success',
                        message: 'File removed successfully.'
                    })
                }
                else {
                    this.ESSEnableDisable(res) 
                    this.$message({
                        type: 'error',
                        message: res.data.Message
                    })
                }
            })
        },

        uploadDocument() {
            if (this.isProjectTab && this.documentsTableData.length > 0 && this.status == 'default' && this.documentType != "OtherDocuments") {
                this.updateDocument(this.documentsTableData[0])
            }
            else {
                this.doValidation = false
                let mockObj = {
                    "DocumentId": "",
                    "DocumentData": []
                }

                this.documentsTableHeader.forEach((h) => {
                    mockObj.DocumentData.push({
                        "Key": h.Key,
                        "Value": ""
                    })
                })

                this.modalType = `Upload`
                this.oldFieldValues = mockObj
                this.fieldValues = mockObj
                this.show = true
            }
        },

        initiateDocument() {
            if (this.isProjectTab && this.documentsTableData.length > 0 && this.status == 'default' && this.documentType != "OtherDocuments") {
                this.updateDocument(this.documentsTableData[0])
            }
            else {
                this.doValidation = false
                let mockObj = {
                    "DocumentId": "",
                    "DocumentData": []
                }

                this.documentsTableHeader.forEach((h) => {
                    mockObj.DocumentData.push({
                        "Key": h.Key,
                        "Value": ""
                    })
                })

                this.modalType = `Upload`
                this.oldFieldValues = mockObj
                this.fieldValues = mockObj
                this.requestType = 'eSign'
                this.show1 = true
            }
        },

        sendRequest() {
            let obj = {}
            let DataList = {}
            DataList.GenericList = []
            DataList.GenericList.push(this.selectedDocumentList)
            obj.DataList = DataList
            if(obj.DataList.GenericList[0].DocumentType == 'RFEDocumentInfo'){
                this.msgShow = true
            }else{
                this.show1 = false
                this._requestDocumentPrivate(obj)
            }

        },

        _requestDocumentPrivate(obj){
            this.$loading({"loadingText": "Sending Request..."})
            ajax.put(`Onboarding/SendRequestForDocuments?consultantId=${this.ConsultantId}&jobId=${this.JobId}&isRequested=true&h1bId=${this.H1BId}`, obj, (res) => {

                this.$loading({ "loadingText": "Sending Request..." }).close()

                if (res.data.State === true) {

                    this.$message({
                        type: 'success',
                        message: "Request for document is sent."
                    })
                    let obj ={}
                    obj.Id = this.H1BId
                    obj.JobId = this.JobId
                    obj.ConsultantId = this.ConsultantId
                    events.fire('h1bInitiatedSuccess')

                }
                else {
                    this.ESSEnableDisable(res) 
                    this.$message({
                        type: 'error',
                        message: res.data.Message
                    })
                }
                // this.checkAndEmitESign()
            })
        },

        // load page after e-sign
        onCloseLoadPage(){
            this.openESign = false
            events.fire('h1bInitiatedSuccess')
        },

        upload() {
            this.doValidation = true
            if (this.isFormValid === true) {
                let model = Object.assign({}, this.documentList)

                model.MetadataValues = [this.fieldValues]

                this.show = false

                let obj = {}

                if (this.fileUploadUrl.indexOf("/Onboarding/SaveOrUpdateRequestedDocument") !== -1) {
                    obj.GenericList = [model]
                } else {
                    obj = model
                    if (obj.LCAId == null || obj.LCAId == '') {
                        obj.LCAId = this.LCAId
                    }

                }

                this.$loading({ 'loadingText': 'Saving...' })

                ajax.put(this.fileUploadUrl, obj, (res) => {

                    if (res.data.State === true) {
                        this.$message({
                            type: 'success',
                            message: 'Saved successfully.'
                        })

                        this._addOrUpdateMetaValues(res.data.DocumentId, this.fieldValues)

                    } else {
                        this.ESSEnableDisable(res) 
                        this.$message({
                            type: 'error',
                            message: res.data.Message
                        })
                    }

                    this.$loading().close()
                })
            }
        },
        uploadESign() {
            this.doValidation = true

            if (this.isFormValid === true) {
                let model = Object.assign({}, this.documentList)

                //model.MetadataValues = [this.fieldValues]

                this.show = false

                let obj = {}

                if (this.fileUploadUrl.indexOf("/Onboarding/SaveOrUpdateRequestedDocument") !== -1) {
                    obj.GenericList = [model]
                } else {
                    obj = model
                    if (obj.LCAId == null || obj.LCAId == '') {
                        obj.LCAId = this.LCAId
                    }

                }
                this.$loading({ 'loadingText': 'Saving...' })

                ajax.put(this.fileUploadUrl, obj, (res) => {

                    if (res.data.State === true) {
                        this.request = {
                            consultantId: this.ConsultantId,
                            jobId: this.JobId,
                            requestFor:'candidate'
                        }
                        obj.MetadataValues[0].DocumentData.forEach((d) => {
                            if(d.Key == 'DocumentUrl'){
                                this.esignDocUrl = d.Value
                            }
                        })
                        this.esignDocId = res.data.DocumentId
                        this._addOrUpdateMetaValues(res.data.DocumentId, this.fieldValues)
                        this.show1 = false
                        this.openESign = true

                    } else {
                        this.ESSEnableDisable(res) 
                        this.$message({
                            type: 'error',
                            message: res.data.Message
                        })
                    }

                    this.$loading().close()
                })
            }
        },
        cancelUpload() {
            this.show = false
            this.fieldValues = __.cloneDeep(this.oldFieldValues)
        },
        cancelUpload1() {
            this.msgShow = false
            this.show1 = false
            this.fieldValues = __.cloneDeep(this.oldFieldValues)
        },

        closePopUp(){
            this.openEffectiveDateHistoryPopup = false;
        },



        // Private Methods
        _getDocumentDataIndexByKey(m, key) {
            return m.DocumentData.findIndex((d) => { return d.Key == key })
        },

        _updateApprovalStatus(status) {
            let cDocumentList = __.cloneDeep(this.documentList)
            cDocumentList.MetadataValues[0].DocumentStatus = status
            this.$emit('onDocumentUpdate', cDocumentList)
        },
        _addOrUpdateMetaValues(id, fieldValues) {
            // Find if the Id is present
            let cDocumentList = __.cloneDeep(this.documentList)
            let index = cDocumentList.MetadataValues.findIndex((d) => { return d.DocumentId == id })

            if (index !== -1) {
                // Existing
                cDocumentList.MetadataValues[index].DocumentData = fieldValues.DocumentData

                // Update Document Status while upload or update
                cDocumentList.MetadataValues[index].DocumentStatus = "ReviewPending"

                this.$emit('onDocumentUpdate', cDocumentList)
            } else {
                // New
                let model = {}
                model.DocumentId = id
                model.DocumentData = fieldValues.DocumentData

                // Update Document Status while upload or update
                model.DocumentStatus = "ReviewPending"

                cDocumentList.MetadataValues.push(model)

                this.$emit('onDocumentUpdate', cDocumentList)
            }
        },

        _removeMetaValues(id) {
            // Find the index by document Id
            let cDocumentList = __.cloneDeep(this.documentList)
            let index = cDocumentList.MetadataValues.findIndex((d) => { return d.DocumentId == id })

            cDocumentList.MetadataValues.splice(index, 1)

            this.$emit('onDocumentUpdate', cDocumentList)

        },
        
        GetShowNotes(documentData){
            if(documentData != null && documentData.length != 0){
            var notes = documentData.find(x => x.Key == "Notes");
                if(notes != null && notes != undefined){
                    return notes.Value != '' ? true : false;
                }
                else return false
            }
            else return false
        },

        openEffectiveDateHistory(directDeposits){
            if(directDeposits && directDeposits.length > 0 && directDeposits[0].DirectDepositLogViewModels && directDeposits[0].DirectDepositLogViewModels.length > 0){
                this.effectiveDateData = directDeposits[0].DirectDepositLogViewModels
            }
            this.$loading({ 'loadingText': 'Loading...' })
            setTimeout(() => {
                this.$loading({}).close()
                this.openEffectiveDateHistoryPopup = true
            },300)
        },

        
    }
  }
</script>

<style lang="scss" scoped>

    @import "~styles/framework/vue-utils";

    @import "~styles/framework/bootstrap/progress-bars";

    $default-border-color : #c2c2c2; $default-background-color: #fdfdfd; $success-border-color : #a4f3b5; $success-background-color: #f4fef7; .document-list {
        /*border-bottom: 1px dashed #ccc;*/
        padding: 15px 10px 15px 0;
    }

    .document-list__header {
        position: relative;
        z-index: 1;
    }

    .document-list__heading {
        padding: 5px 10px;
        border: 1px solid $default-border-color;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: $default-background-color;
        /*float: left;*/
    }

    .document-list__status {
        background: $default-border-color;
        color: $default-background-color;
        padding: 0px 5px;
        border-radius: 100%;
    }

    .document-list__controls {
        text-align:right;
        padding-right: 18px;
        margin-top:10px;
    }

    .document-list.document-list--success {
        .document-list__heading

    {
        border: 1px solid #1DC942;
        background: $success-background-color;
    }


    .document-list__status {
        background: $success-border-color;
        color: #1DC942;
    }

    }

    .document-list__body {
        position: relative;
        padding-top: 15px;
        padding-left: 5px;
        /*top: -18px;*/
    }

    .headerStyle {
        font-size: 13px;
        font-weight: normal !important;
    }

    .historylink{
        cursor:pointer;
        color:#0091FF;
        font-weight: 600px;
        text-decoration:underline;
        font-style:italic;
    }

    .single_line_text{
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        white-space: nowrap;
    }

    .dataStyle {
        font-weight: 600 !important;
        color: #143361;
        display: block;
    }

    .dataStyleNotes {
        word-break: break-word;
        font-weight: 600 !important;
        color: #143361;
        display: block;
    }

    .progress {
        overflow: hidden;
        height: 5px;
        margin-bottom: 0;
        background-color: #f5f5f5;
        border-radius: 10px;
        -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    }

    .upload_div, .upload_file_div {
        padding: 35px;
        background: #FAFEFF;
        border: 2px dashed #ccc;
        border-radius: 8px;
        display: table;
        width: 100%;
        cursor: pointer;
        text-align: center;
        &.dragover

    {
        background: #fff;
    }

    }

    .upload_file_div {
        padding: 15px;
        cursor: default;
    }

    .upload-inner {
        display: table-cell;
        vertical-align: middle;
        padding: 15px;
        width: 15%;
    }

    .width-70 {
        width: 70%;
    }

    .margin-top-25 {
        margin-top: 25px;
    }

    .upload_img {
        padding: 15px 0 20px 0;
    }

    .upload_text {
        padding: 0 0 20px 0;
    }

    .icon {
        width: 50px;
    }

    .icon1 {
        width: 35px;
    }

    .info {
        margin: 0;
        font-size: 13px;
        line-height: 18px;
        color: #999;
        display: inline-block;
    }

    .file_name_span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 600px;
        display: inline-block;
    }


    /* Error */
    .error-holder {
        margin: 10px 0;
    }

    .error-msg {
        color: $ob-error-red;
    }


    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }


    /* Signers list */
    .signature-holder {
        .document-signer

    {
        font-size: 16px;
        font-weight: 600;
        color: #337AB5;
    }

    .signauture-success {
        font-size: 9px;
        color: #FFFFFF;
        background: #3CB55B !important;
    }

    .signauture-pending {
        font-size: 9px;
        color: #FFFFFF;
        background: #008BE7 !important;
    }

    .document-signature-details {
        font-size: 14px;
        color: #2A2A2A;
    }

    .intiated-esign {
        margin-right: 20px;
    }
    }
</style>


<style lang="scss">


    .dropdown-list {
        width: auto;
        font-size: 12px;
    }
    /* expired list*/
    .showExpired {
        background: #F1F1F1 !important;
        border: 1px solid #8A8A8A !important;
    }

    .showExpiredStaus {
        color: #676a6c !important;
        background: #CECECE !important;
    }
    /* animation duration and fill mode */
    .animation {
        animation-duration: 1s;
        animation-fill-mode: both;
        display: inline-block;
    }

    /* bounceOutLeft animation declaration & iteration counting */
    .bounceOutLeft {
        animation-name: bounceOutLeft
    }

    /* bounceOutLeft animation keyframes */
    @keyframes bounceOutLeft {
        18% {
            transform: translate3d(27px, 0, 0)
        }

        33% {
            transform: translate3d(-12px, 0, 0)
        }

        48% {
            transform: translate3d(8px, 0, 0)
        }

        100% {
            transform: translate3d(-300%, 0, 0)
        }
    }

    @keyframes bounceInUp {
        0% {
            opacity: 0;
            -webkit-transform: translateY(2000px);
            -ms-transform: translateY(2000px);
            transform: translateY(2000px);
        }

        60% {
            opacity: 1;
            -webkit-transform: translateY(-30px);
            -ms-transform: translateY(-30px);
            transform: translateY(-30px);
        }

        80% {
            -webkit-transform: translateY(10px);
            -ms-transform: translateY(10px);
            transform: translateY(10px);
        }

        100% {
            -webkit-transform: translateY(0);
            -ms-transform: translateY(0);
            transform: translateY(0);
        }
    }

    .bounceOuttop {
        animation-name: bounceInUp
    }

    .select-type, .upload-document {
        padding: 10px 0;
    }

    .status-color {
        color: #24c024 !important;
    }

    .instractions_text {
        display: inline-block;
        width: 100%;
        padding-bottom: 10px;
        p

    {
        color: #df3a62
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSComponents/DocumentList/ESSDocumentList.vue